<template>
  <div class="carrossel-step-publico">
    <h3 class="step-title">Público</h3>
    <p class="step-subtitle">Defina quem verá o {{ entityLabel }} no site.</p>

    <v-divider class="mb-5" />

    <v-row>
      <v-col cols="12" md="6" v-if="showSegmentoField">
        <label class="field-label">Segmento de clientes</label>
        <FormAutocomplete
          v-model="wizardState.segmentoClienteSelecionado"
          placeholder="Todos os segmentos"
          :options="segmentosCliente"
          chips
          clearable
          @input="onDirty"
        />
        <small class="field-hint">
          Opcional. Sem seleção, o {{ entityLabel }} será exibido para todos os
          segmentos.
        </small>
      </v-col>

      <v-col cols="12" md="6" v-if="showUserLoginTypeField">
        <label class="field-label">Exibir para usuários</label>
        <FormAutocomplete
          v-model="wizardState.appearanceState.userLoginType"
          placeholder="Selecione o tipo de usuário"
          :options="userLoginTypeOptions"
          :clearable="false"
          @input="onDirty"
        />
        <small class="field-hint">
          Restringe a exibição conforme o status de login do visitante.
        </small>
      </v-col>
    </v-row>

    <v-row v-if="showPesquisaField">
      <v-col cols="12">
        <FormSwitch
          class="switch-pesquisa"
          :label="pesquisaLabel"
          v-model="wizardState.carrossel.config.showOnPesquisaAtivada"
          @input="onDirty"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import FormAutocomplete from "@/components/form/FormAutocomplete";
import FormSwitch from "@/components/form/FormSwitch";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import {
  USER_LOGIN_TYPE_OPTIONS,
  validateStepPublico
} from "../../utils/utilCarrossel";

export default {
  name: "CarrosselStepPublico",
  components: {
    FormAutocomplete,
    FormSwitch
  },
  props: {
    wizardState: {
      type: Object,
      required: true
    },
    segmentosCliente: {
      type: Array,
      default: () => []
    },
    showComponente: {
      type: Function,
      required: true
    },
    productEditorMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enumModules: ModulesEnum,
      userLoginTypeOptions: USER_LOGIN_TYPE_OPTIONS
    };
  },
  computed: {
    entityLabel() {
      return this.productEditorMode ? "vitrine" : "carrossel";
    },
    pesquisaLabel() {
      return `Exibir ${this.entityLabel} com a pesquisa ativada`;
    },
    showSegmentoField() {
      if (this.productEditorMode) {
        return this.showComponente([
          this.enumModules.COMMERCE_APP,
          this.enumModules.WEB_COMMERCE
        ]);
      }
      return this.showComponente([
        this.enumModules.COMMERCE_APP,
        this.enumModules.WEB_COMMERCE
      ]);
    },
    showUserLoginTypeField() {
      return this.showComponente([
        this.enumModules.COMMERCE_APP,
        this.enumModules.WEB_COMMERCE
      ]);
    },
    showPesquisaField() {
      return this.showComponente([
        this.enumModules.COMMERCE_APP,
        this.enumModules.WEB_COMMERCE
      ]);
    }
  },
  methods: {
    onDirty() {
      this.$emit("dirty");
    },
    validate() {
      const result = validateStepPublico();
      if (!result.valid && result.message) {
        this.$vueOnToast.pop("warning", result.message);
      }
      return result.valid;
    },
    syncToCarrossel() {
      const segmento = this.wizardState.segmentoClienteSelecionado;
      if (segmento && typeof segmento === "object" && segmento.value) {
        this.wizardState.carrossel.idsegmentocliente = segmento.value;
      } else if (segmento) {
        this.wizardState.carrossel.idsegmentocliente = segmento;
      } else {
        this.wizardState.carrossel.idsegmentocliente = null;
      }

      if (!this.wizardState.carrossel.config) {
        this.wizardState.carrossel.config = {};
      }

      this.wizardState.carrossel.config.userLoginType =
        this.wizardState.appearanceState?.userLoginType || "AMBOS";
    }
  }
};
</script>

<style scoped>
.step-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 4px;
  text-align: left;
}

.step-subtitle {
  color: #666;
  margin-bottom: 24px;
  text-align: left;
}

.field-label {
  font-weight: 600;
  display: block;
  margin-bottom: 8px;
  margin-left: 10px;
  text-align: left;
  width: 100%;
}

.field-hint {
  display: block;
  color: #888;
  font-size: 12px;
  margin-top: -8px;
  margin-left: 10px;
  margin-bottom: 10px;
  text-align: left;
}

.switch-pesquisa {
  margin-left: 10px;
}
</style>
